//Replicate for stage and prod
export const environment = {
  production: false,
  environment: 'stage',
  title: 'Sierra Production',
  name: 'sierra-production',
  asset: {
    stationAssetTypeReference: '67abfb9aee06eac3505f9834',
  },
  // E-signature pages (preview): off in prod; elsewhere only for the SignaturePreview role.
  features: {
    signature: true,
    /** Access catalog page (#6265): preview, off in prod. */
    accessCatalog: true,
  },
  proxyUrls: {
    assetApi: 'https://asset.api.stage.sierra-erp.com',
    itemApi: 'https://asset.api.stage.sierra-erp.com',
    userMasterApi: 'https://user.api.stage.sierra-erp.com',
    productionApi: 'https://production.api.stage.sierra-erp.com',
    inventoryApi: 'https://inventory.api.stage.sierra-erp.com',
    orderApi: 'https://order.api.stage.sierra-erp.com',
  },
};
